import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class LocationService {
  static async update(id, data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation LOCATION_UPDATE(
          $id: String!
          $data: LocationInput!
          $manage: ManageInput!
        ) {
          locationUpdate(id: $id, data: $data,  manage: $manage) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage,
      },
    });

    return response.data.locationUpdate;
  }

  static async destroyAll(ids, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation LOCATION_DESTROY($ids: [String!]!,  $manage: ManageInput!) {
          locationDestroy(ids: $ids,  manage: $manage)
        }
      `,

      variables: {
        ids,
        manage,
      },
    });

    return response.data.locationDestroy;
  }

  static async create(data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation LOCATION_CREATE($data: LocationInput!,  $manage: ManageInput!) {
          locationCreate(data: $data,  manage: $manage) {
            id
          }
        }
      `,

      variables: {
        data,
        manage,
      },
    });

    return response.data.locationCreate;
  }

  static async import(values, importHash, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation LOCATION_IMPORT(
          $data: LocationInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          locationImport(data: $data, importHash: $importHash,  manage: $manage)
        }
      `,

      variables: {
        data: values,
        importHash,
        manage,
      },
    });

    return response.data.locationImport;
  }

  static async find(id, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query LOCATION_FIND($id: String!,  $manage: ManageInput!) {
          locationFind(id: $id,  manage: $manage) {
            id
            name
            latitude
            longitude
            information
            access
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        manage,
      },
    });

    return response.data.locationFind;
  }

  static async list(filter, orderBy, limit, offset, manage) {
    if ( !manage.subpropertyId ) return { rows: [], count: 0};

    const response = await graphqlClient.query({
      query: gql`
        query LOCATION_LIST(
          $filter: LocationFilterInput
          $orderBy: LocationOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          locationList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
              id
              name
              latitude
              longitude
              access
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        manage,
      },
    });

    return response.data.locationList;
  }

  static async listAutocomplete(query, limit, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query LOCATION_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          locationAutocomplete(query: $query, limit: $limit,  manage: $manage) {
            id
            label
          }
        }
        `,

      variables: {
        query,
        limit,
        manage,
      },
    });

    return response.data.locationAutocomplete;
  }
}
